module.exports = __webpack_public_path__ + "static/media/03-checkbox.41909515.png";